var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97848 3.14645C5.78322 3.34171 5.78322 3.65829 5.97848 3.85355L10.1249 8L5.97848 12.1464C5.78322 12.3417 5.78322 12.6583 5.97848 12.8536C6.17374 13.0488 6.49032 13.0488 6.68558 12.8536L11.1856 8.35355C11.3808 8.15829 11.3808 7.84171 11.1856 7.64645L6.68558 3.14645C6.49032 2.95118 6.17374 2.95118 5.97848 3.14645Z",
    fill: "#9B9DAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.4b639102ed3c568c381fdb6e001d2ee6.svg";
export { ForwardRef as ReactComponent };